/* @sravni/react-design-system version 0.2.50 */
var css = "._1xeuzyk._wgkhn8 {\n  padding: 8px;\n}\n._148utmz {\n  cursor: pointer;\n}\n._148utmz:focus-visible {\n  outline: none;\n}\n._148utmz._1t3578k {\n  cursor: auto;\n}\n._1sr65q7 {\n  max-height: 341px;\n}\n";
var modules_c052660e = {"container":"_1xeuzyk","dropdown":"_wgkhn8","triggerElement":"_148utmz","disabled":"_1t3578k","menu":"_1sr65q7"};
import "../../../assets/components/Dropdown/styles/Dropdown.module.less-7607c649.css";

export default modules_c052660e;
export { css };
